import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleUserInRoles = {
  namespaced: true,

  state: {
    name: 'userInRoles',
    userInRoles: [],
  },

  mutations,
  getters,
  actions
}

export default moduleUserInRoles;